<template>
  <div>
    <Navbar />
    <section class="category-page">
      <Header
        formID="get-offer-mobile"
        :formData="formData"
        :insuranceType="insuranceType"
        approveRoute="cep-telefonu-sigortasi-teklif-onay"
      />
      <get-quote :quoteCard="quoteCard" />
      <category-info :categoryInfo="categoryInfo" />
      <app-contracted-insurance-companies :buttons="buttonData" />
      <frequently-asked-questions
        :faqTitle="faqTitle"
        :faqTitleDesc="faqTitleDesc"
        :questions="questions"
      />
    </section>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/component/navbar/Navbar'
import Header from '@/component/categories/Header'
import GetQuote from '@/component/categories/GetQuote'
import categoryInfo from '@/component/categories/CategoryInfo'
import appContractedInsuranceCompanies from '@/component/contracted-insurance-companies/AppContractedInsuranceCompanies'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import MobilePhoneInsData from '@/data/category-page-data/MobilePhoneInsurance'
import Footer from '@/component/footer/Footer'
import QuotationType from '@/data/QuotationType'
import { filteredButtons } from '@/mixins/FilteredButtons'

export default {
  metaInfo: {
    title: 'En Uygun Cep Telefonu Sigortası Fiyatları İçin Teklif Alın',
    meta: [
      {
        name: 'description',
        content:
          'Cep telefonu sigortası yapan şirketleri karşılaştırarak , telefonunuzu cep telefonu sigortası kapsamı altına alın. Telefon tamir masraflarını dert etmeyin.'
      }
    ]
  },
  mixins: [filteredButtons],
  name: 'MobilePhoneInsurance',
  components: {
    Navbar,
    Header,
    GetQuote,
    categoryInfo,
    appContractedInsuranceCompanies,
    frequentlyAskedQuestions,
    Footer
  },
  data () {
    return {
      insuranceType: QuotationType.MOBILEPHONE,
      categoryInfo: MobilePhoneInsData.categoryInfo,
      getPrice: MobilePhoneInsData.getPrice,
      faqTitle: MobilePhoneInsData.faqTitle,
      faqTitleDesc: MobilePhoneInsData.faqTitleDesc,
      questions: MobilePhoneInsData.questions,
      formData: {
        description: {
          upperText: 'En İyi Fiyat, Tam Korumat',
          title: 'En Ucuz Cep Telefonu Sigortası Sorgulama ',
          bottomText: 'Cep Telefonu Sigortası Fiyatlarını Karşılaştırın'
        },
        button: 'TEKLİF AL',
        fullname: true,
        identity: true,
        phone: true,
        email: true
      },
      quoteCard: {
        title: 'Alokasko’dan Cep Telefonu Sigortası Almak Çok Kolay!',
        description: 'Cep telefonu sigortası yaptırın, riskleri düşünmeyin.',
        content: [
          {
            id: 1,
            icon: 'fas fa-file-alt',
            title: '1 Yıllık Güvence',
            desc:
              'Planınızı başlatmak için telefonunuzun fatura bilgilerini iletmeniz yeterlidir. Şirketlerin telefonunuza özel sunacağı fiyatları araştıracağız ve size uygun teklifleri saniyeler içinde bulacağız.'
          },
          {
            id: 2,
            icon: 'fab fa-cc-visa',
            title: '9 Taksit İmkânı',
            desc:
              'Bulduğunuz tekliften memnun olduğunuzda, satın alma işleminizi tamamlayabilir, taksit seçeneklerinden yararlanabilirsiniz.'
          },
          {
            id: 3,
            icon: 'fas fa-clipboard-check',
            title: 'Online Sistem İle 1 Dakikada Satın Al',
            desc:
              'Sigorta poliçeniz için evrak işlerini unutun. Saatler ve günler harcamaya hayır deyin. Alokasko.com ile cep telefonu sigortanızı anında düzenleyin.'
          },
          {
            id: 4,
            icon: 'fas fa-users-cog',
            title: 'Uzman Desteği',
            desc:
              'İster bir sigorta poliçesinin satın alınmasıyla ilgili olsun, ister bir tazminat talebinin çözümü sırasında yardım talebiniz olsun, hizmetinizdeyiz.'
          }
        ]
      }
    }
  },
  mounted () {
    this.filterButtons('Cep Telefonu Sigortası')
  }
}
</script>
<style lang="scss">
@import '@/css/app.scss';
</style>
